export default {
  "box-name": "cn-trading-body",
  lang: "ko",
  了解指数差价合约: "배우다현물 지수 CFD",
  "public-btn-text1": "거래시간 안내",
  "public-btn-text2": "전체 종목 및 스프레드 보기",
  screen0: {
    title: "거래 상품",
    desc: "100개 이상의 인기 금융 상품을 기관급 가격으로 거래하세요.전 세계에서 가장 유동성 높은 시장에 접속해, 언제든 최고의 거래 기회를 포착할 수 있습니다.",
    btn: "더 알아보기",
  },
  screen1: {
    link1: "외환",
    link2: "원자재",
    link3: "지수 CFD",
    link4: "주식 CFD",
    link5: "ETF CFD",
  },
  screen2: {
    title: "외환",
    text1: "최대 레버리지 500:1",
    text2: "평균 체결 속도 20ms",
    imgUrl: "trade-01",
    title2: "최저 0핍 스프레드로 37종 통화쌍 거래 가능",
    desc2:
      "세계에서 가장 큰 금융시장 <br/>2019년 9월 국제청산은행(BIS) 보고서에 따르면, 세계 외환시장의 일 평균 거래량은 사상 최고치인 6.6조 달러에 달했습니다. ",
  },
  screen3: {
    title: "원자재",
    text1: "유연한 레버리지",
    text2: "업계 최저 수준의 스프레드",
    text3: "자유로운 포지션 운영",
    title2: "분산 투자를 원하신다면, 원자재 거래는 현명한 선택입니다",
    desc2: "귀금속, 원유, 천연가스 등",
  },
  screen4: {
    title: "지수 CFD",
    text1: "실시간 가격",
    text2: "평균 체결 속도 20ms",
    text3: "최대 레버리지 100:1",
    text4: "투명한 거래 환경 ",
    title2: "글로벌 주요 지수를 선별해, 가장 가치 있는 시장을 발굴합니다.",
  },
  screen5: {
    title: "주식 CFD",
    text1: "업계 최저 수준의 거래 비용",
    text2: "인기 미국주식 50종목 선별",
    text3: "기관급 유동성 제공",
    text4: "양방향 거래 기회",
    title2: "주식 CFD로 글로벌 대표 기업에 손쉽게 투자하세요",
  },
  screen6: {
    title: "ETF CFD",
    title2:
      "ETF CFD로 글로벌 인기 섹터 및 산업 지수를 손쉽게 한 곳에서 거래하세요",
    text1: "자산 보유 없이 거래 가능",
    text2: "레버리지 거래 가능",
    text3: "다양한 종목",
  },
};
